const createAdoAds = (window, document) => {
  const scriptTag = document.createElement('script');

  // eslint-disable-next-line unicorn/prevent-abbreviations
  scriptTag.src = 'https://pracuj.adocean.pl/files/js/ado.js';
  scriptTag.async = true;
  scriptTag.addEventListener('load', () => {
    if (typeof window.ado !== 'object') {
      window.ado = {};
      window.ado.config = window.ado.preview = window.ado.placement = window.ado.master = window.ado.slave = function () {};
    }
    

    window.ado.config({
      mode: 'new',
      xml: false,
      consent: true,
      characterEncoding: true
    });

    window.ado.preview({ enabled: true });

    window.ado.placement({id: 'ado-cKoAJVyeN7PjAtKNiVL5b_sYkUXTM6dQ0JbtrGg6OFv.17', server: 'pracuj.adocean.pl' });
  });

  document.head.appendChild(scriptTag);
};


export default createAdoAds;
